var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"positionRelative"},[(_vm.isLoading)?_c('LoadingOverlay'):_vm._e(),_c('ContactForm',{on:{"submitContactForm":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }